/**
 * Analytics helper functions
 */
import axios from "axios"
import getFromRequest from "./getFromRequest"

/**
 * We track which CTA was clicked based on a data-attribute telling us which one it was
 * @usage
 *
 * ```
 * <a
 *  href="/page/"
 *  onClick={() => {
 *    trackCta("Label")
 *  }}>Link</a>
 * ```
 *
 * @param label - string
 * @return {void}
 */
export const trackCta = function (label) {}

/**
 * We track whenever we get a form error

 * @param label - string
 * @return {void}
 */
export const trackFormError = function (label) {}

const determineUtmSource = () => {
  let utm = {}
  const utmSource = getFromRequest("utm_source")
  const utmTerm = getFromRequest("utm_term")

  if (utmSource) {
    utm.utmSource = utmSource.toLowerCase()
    if (utmTerm) {
      utm.utmTerm = utmTerm.toLowerCase()
    }
    return utm
  }

  const gspk = getFromRequest("gspk")
  if (gspk) {
    // If they came from partner stack, then log that, and use the partner key as the term.
    utm.utmSource = "partnerstack"
    utm.utmTerm = gspk
    return utm
  }

  if (document.referrer.length > 0) {
    utm.utmSource = "web"
    utm.utmTerm = document.referrer
    return utm
  }

  utm.utmSource = "direct"
  return utm
}

/**
 * utmTrack
 * When the user lands on the page with some GA tracking QA params e.g.
 * `?utm_source=a+website&utm_term=a+term`
 * then we send these codes to
 * the Timetastic App API so we know where the user originally came from. When we check localStorage
 * if we find we've called the API before then we don't need to do it again.
 *
 * @return {void}
 */
export const utmTrack = function () {
  try {
    // GatsbyJS does not have window in `build` mode
    if (typeof window === "undefined") {
      return
    }

    if (window.localStorage && window.localStorage.getItem("utmData")) {
      // We've already got a utm source in localStorage, no need to set it again.
      return
    }

    let utm = determineUtmSource()

    //Log the landing page
    utm.landingPage = document.documentURI
    utm.firstSeen = new Date().toJSON()
    utm.firstReferrer = document.referrer

    if (utm.utmSource) {
      let encoded = encodeURIComponent(btoa(JSON.stringify(utm)))
      localStorage.setItem("utmData", encoded)
    }
  } catch (error) {
    var utmError = { error: error.toString() }
    var encodedError = encodeURIComponent(btoa(JSON.stringify(utmError)))
    localStorage.setItem("utmData", encodedError)
  }
}

/**
 * attachUtm
 *
 * Called from any Signup link to attach the UTM data to the URL
 * and redirect to the signup page
 *
 * @return {string}
 */
export const doSignupClick = function (startWithPro) {
  if (typeof startWithPro == "undefined") {
    startWithPro = false
  }

  const qsParams = new URLSearchParams({ pro: startWithPro })
  const append = localStorage.getItem("utmData")
  if (append) {
    qsParams.append("z", append)
  }

  const gsxid = localStorage.getItem("ps_gsxid")
  if (gsxid) {
    qsParams.append("gsxid", gsxid)
  }

  const gspk = localStorage.getItem("ps_gspk")
  if (gspk) {
    qsParams.append("gspk", gspk)
  }

  const signupUrl = `https://app.timetastic.co.uk/signup/?${qsParams.toString()}`

  window.location.href = signupUrl
}
